import '../src/styles/tailwind.css'
import { createRoot } from 'react-dom/client'
import App from '../src/App'

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('root')
  if (container) {
    createRoot(container).render(<App />)
  }
})
